module.exports = __webpack_public_path__ + "img/logo.8140896e.png";